module.exports = __webpack_public_path__ + "static/media/24.082705b0.png";